import React from "react";
//outsource
import { Row, Col, Table } from "antd";
import DialogTimeAdd from "../dialog/dialog_time_add";
//redux
import { useDispatch, useSelector } from "react-redux";
import {
  reportDataSelector,
  totalWorkingSelector,
  totalBreakingSelector,
  rangeSelector,
  photosSelector,
  locationsSelector,
} from "../../../store/report/report.selector";
import {
  secondsToHoursAndMinuteFormat,
  getHeaderByRange,
  getDataRows,
} from "../../../utils/refine.timetracking";

const TimeTable = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const reportData = useSelector(reportDataSelector);
  const totalWorking = useSelector(totalWorkingSelector);
  const totalBreaking = useSelector(totalBreakingSelector);
  const range = useSelector(rangeSelector);
  const photos = useSelector(photosSelector);
  const locations = useSelector(locationsSelector);

  // console.log({ reportData });
  //convert
  const formatWorking = secondsToHoursAndMinuteFormat(totalWorking);
  const formatBreaking = secondsToHoursAndMinuteFormat(totalBreaking);
  const finalWorking = formatWorking || "--:--";
  const finalBreaking = formatBreaking || "--:--";

  // -------------------------- FUNCTION --------------------------
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const columns = getHeaderByRange(range, reportData);
  const { final: dataRange } = getDataRows(reportData, photos, locations);
  console.log({ dataRange });
  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col style={{ marginTop: 5 }} align="right" span={24}>
        Total:{" "}
        <span style={{ color: "#1a76d2", fontWeight: "bold" }}>
          {finalWorking}
        </span>{" "}
        |{" "}
        <span style={{ fontWeight: "bold", color: "red" }}>
          {finalBreaking}
        </span>
      </Col>
      <Col span={24}>
        <Table
          rowSelection={{ type: "checkbox", ...rowSelection }}
          bordered
          columns={columns}
          dataSource={dataRange || []}
          pagination={false}
        />
      </Col>
      <DialogTimeAdd />
    </Row>
  );
};

export default TimeTable;
